import { AppLogoHeader } from 'components/_common/Icons';
import LogoLoader from 'components/_common/LogoLoader';
import CustomerAPI from 'config/api/CustomerAPI';
import { t } from 'i18next';
import 'modules/admin/assets/scss/systemStatusPage.scss';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import APIService from 'services/api.service';
import { setMaintenanceMode } from 'store/auth/slices/SystemStatusSlice';

const POLL_MS = 15000;

export default function Maintenance() {
  const dispatch = useDispatch();

  useEffect(() => {
    const checkStillInMaintenance = async () => {
      const result: any = await APIService.submitData(CustomerAPI.settings.url, {
        key: ['maintenance_mode'],
      });
      if (result?.status && result?.data?.maintenance_mode !== 'true') {
        dispatch(setMaintenanceMode(false));
      }
    };

    const interval = setInterval(checkStillInMaintenance, POLL_MS);
    return () => clearInterval(interval);
  }, [dispatch]);

  return (
    <div className="system-status-page d-flex flex-column align-items-center justify-content-center vh-100 text-center px-3">
      <img src={AppLogoHeader} alt="MyLocalGunShop.com" className="system-status-page__logo" />
      <LogoLoader
        background="dark"
        overlay={false}
        fullscreen={false}
        messages={[
          t('maintenance_message_1'),
          t('maintenance_message_2'),
          t('maintenance_message_3'),
        ]}
      />
      <h3 className="system-status-page__title mt-3 mb-2">{t('maintenance_title')}</h3>
      <p className="system-status-page__text mb-0">{t('maintenance_subtitle')}</p>
      <p className="system-status-page__text mb-0">{t('maintenance_refresh_note')}</p>
      <p className="system-status-page__text">
        {t('maintenance_support_note')}{' '}
        <a href="mailto:support@mylocalgunshop.com" className="system-status-page__link">
          support@mylocalgunshop.com
        </a>
      </p>
    </div>
  );
}
